<template>
    <div>
        <div>
            <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='垃圾询盘屏蔽处理设置' }">添加
            </a-button>

            <a-popconfirm
                    title="此操作将永久删除, 是否继续?"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="confirm('')"
                    @cancel="()=>{}"
                    :disabled="!hasSelected"
            >
                <a-button   type="primary" :disabled="!hasSelected" :loading="loading"  >
                    删除
                </a-button>
            </a-popconfirm>
            <span style="margin-left: 8px">
            <template v-if="hasSelected">
              {{ `选中 ${selectedRowKeys.length} 项` }}
            </template>
            </span>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"  >
          <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)"
                   :checked="text==1?true:false" :disabled="!$_has('btn_status')"/>
      </span>
            <span slot="action" slot-scope="text, record">
        <a @click="(record)=>{visibleForm = true; titleForm='垃圾询盘屏蔽处理设置'; editId=text.id ; }" >编辑 <a-divider type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm([record.id])"
                  @cancel="()=>{}"
          >
   <a  >删除</a>
  </a-popconfirm>
      </span>
        </a-table>
        <NewForm :visible="visibleForm" :title="titleForm" :editId="editId"
                  @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "/>

    </div>

</template>

<script>
    import API from "./api";
    import NewForm from "./components/newForm"
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [
        // {
        //     title: "id",
        //     dataIndex: "id",
        //     ellipsis: true,
        //     key: "id"
        // },
      {
        title: "屏蔽IP段",
        dataIndex: "ip",
        ellipsis: true,
        key: "ip"
      }, {
        title: "屏蔽时间",
        dataIndex: "create_time",
        ellipsis: true,
        key: "create_time"
      },
        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'index',
        data() {
            return {
                selectedRowKeys: [], // Check here to configure the default column
                visibleForm: false,
                titleForm: "",
                loading: true,
                editId: null,
                jurisdictionId: null,
                visibleJurisdiction: false,
                data: [],
                columns,pagination: {
                pageNo: 1,
                pageSize: 20, // 默认每页显示数量
                onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                onChange: this.getList.bind(this), //点击页码事件
                total: 0, //总条数
                current: 0,
                size: "small",
                showTotal: total => `共 ${total} 条`,
                showQuickJumper: true
              },
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/Set/AInquiryIp"; //设置左侧导航2-2 active
        },
        components: {NewForm},
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            getList(page) {
                API.administrator.GET_AROLE(page||1).then(res => {
                  this.pagination.total = res.data.data.list.total
                  this.pagination.pageSize = res.data.data.list.per_page
                  this.pagination.current = res.data.data.list.current_page
                    this.data = res.data.data.list.data
                    this.loading = false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.administrator.CHANG_STATUS, [Json]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            confirm(id) {
                if(id==''){
                    id=this.selectedRowKeys
                }
                removeById(API.administrator.DELE,id).then(res => {
                    if (res == true) {
                        this.getList()
                        this.selectedRowKeys=[]
                    }
                })
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
